export default __webpack_public_path__ + "static/media/480_business05-jp-mobile.3ca7f702.png";